import type { LexicalBlockNode, LexicalNode } from '../interfaces/cms';

export const isLexicalBlockNode = (
  node: LexicalNode,
): node is LexicalBlockNode => {
  return (
    node.type === 'block' ||
    (node.type === 'inlineBlock' &&
      'fields' in node &&
      typeof node.fields === 'object' &&
      node.fields !== null &&
      'blockType' in node.fields &&
      typeof node.fields.blockType === 'string')
  );
};

export const traverseLexicalNodes = (
  node: LexicalNode,
  callback: (node: LexicalNode) => void,
) => {
  callback(node);

  if (!node.children) {
    return;
  }

  for (const child of node.children) {
    traverseLexicalNodes(child, callback);
  }
};
